/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';
const { string, bool, arrayOf } = proptypes;
import { Typography } from '@one-thd/sui-atomic-components';
import { InfoDrawer } from '@thd-olt-component-react/product-bundle';

const LaundryContainerTitle = ({
  text = '', variantNames = [], wrap = false, isAccordion = false, drawerHeader = null
}) => {
  const words = text.split(' ');
  return (
    <div
      data-testid="container-title"
      className={`sui-flex sui-items-center ${wrap ? 'sui-flex-wrap' : 'sui-flex-nowrap'} sui-whitespace-pre`}
    >
      {
        words.map((word, index) => (
          <Typography
            key={index}
            variant="body-xs"
            weight="bold"
            height="tight"
          >
            {`${word}${index === words.length - 1 ? '' : ' '}`}
          </Typography>
        ))
      }
      <div className="sui-ml-2">
        <InfoDrawer variantNames={variantNames} isAccordion={isAccordion} drawerHeader={drawerHeader} />
      </div>
    </div>
  );
};

LaundryContainerTitle.propTypes = {
  text: string,
  wrap: bool,
  variantNames: arrayOf(string),
  isAccordion: bool,
  drawerHeader: string
};

export default LaundryContainerTitle;